import React from 'react';
import { Box, Typography, LinearProgress } from '@mui/material';
import BaseCard from './BaseCard';
import { ReactComponent as SoftwareIcon } from '../../../images/icons/software_icon.svg';
import { ReactComponent as SoftwareIconFill } from '../../../images/icons/software_icon_fill.svg';
import { customError, darkGrey, dimGrey, lightGrey } from '../../../mainTheme';

interface SoftwareCardProps {
  isSelected?: boolean;
  onClick?: () => void;
  data: {
    version: string;
    upToDate: number;
    needsUpdate: number;
  };
}

export const SoftwareCard: React.FC<SoftwareCardProps> = ({
  isSelected,
  onClick,
  data,
}) => {
  const total = data.upToDate + data.needsUpdate;
  const isNoData = total === 0;
  const progress = (data.upToDate / total) * 100;

  return (
    <BaseCard
      title="Software"
      isSelected={isSelected}
      onClick={onClick}
      icon={isSelected ? <SoftwareIconFill /> : <SoftwareIcon />}
    >
      <Box sx={{ mb: '21px' }}>
        <Typography
          sx={{
            color: dimGrey,
            fontSize: '14px',
            fontWeight: 500,
            lineHeight: '20px',
            letterSpacing: '0.2px',
          }}
        >
          Version: {data.version}
        </Typography>
      </Box>

      <Box sx={{ width: '100%', mb: '16px' }}>
        <LinearProgress
          variant="determinate"
          value={progress}
          sx={{
            height: '10px',
            borderRadius: '8px',
            backgroundColor: isNoData ? lightGrey : customError, // Red for needs update
            '& .MuiLinearProgress-bar': {
              backgroundColor: isNoData ? lightGrey : '#4caf50', // Green for up-to-date
              borderRadius: '8px',
            },
          }}
        />
      </Box>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-evenly',
          alignItems: 'center',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box
            sx={{
              width: 10,
              height: 10,
              borderRadius: '50%',
              bgcolor: '#4caf50',
            }}
          />
          <Typography
            sx={{
              color: dimGrey,
              fontSize: '12px',
              fontWeight: 500,
              lineHeight: '16px',
            }}
          >
            up-to-date{' '}
            <span style={{ fontWeight: 'bold', color: darkGrey }}>
              {data.upToDate}
            </span>
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box
            sx={{
              width: 10,
              height: 10,
              borderRadius: '50%',
              bgcolor: customError,
            }}
          />
          <Typography
            sx={{
              color: dimGrey,
              fontSize: '12px',
              fontWeight: 500,
              lineHeight: '16px',
            }}
          >
            need updating{' '}
            <span style={{ fontWeight: 'bold', color: darkGrey }}>
              {data.needsUpdate}
            </span>{' '}
          </Typography>
        </Box>
      </Box>
    </BaseCard>
  );
};
